
import CreateSeance from '@/components/CreateSeance'
export default {
  components: { CreateSeance },
  layout: 'product',
}
